import * as React from 'react'
import * as Application from 'expo-application'
import { Caption, Divider, List } from 'react-native-paper'
import { StyleSheet } from 'react-native'
import { Linking } from 'react-native'

const About = () => {
  const openAboutLucidcode = () => {
    try {
      Linking.openURL('https://www.lucidcode.com')
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      <List.Item
        title="Application Version"
        right={() => (
          <Caption style={styles.caption}>{Application.nativeApplicationVersion}</Caption>
        )}
      />
      <Divider />
      <List.Item title="About lucidcode" onPress={openAboutLucidcode} />
      <Divider />
    </>
  )
}

const styles = StyleSheet.create({
  caption: {
    marginTop: 5,
  },
})

export default About
